var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-list-tile",
        {
          key: _vm.agentInfos.status,
          staticClass: "itemsListeAgent",
          attrs: { ripple: "", id: "agent_" + _vm.agentInfos.agentID }
        },
        [
          _vm.sessionsChatAgent.length
            ? _c(
                "v-badge",
                {
                  attrs: { overlap: "", color: "green", left: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "badge",
                        fn: function() {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(_vm.sessionsChatAgent.length))
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    4153551990
                  )
                },
                [
                  _vm._v(" "),
                  _c("wz-avatar", {
                    class: _vm.agentInfos.status,
                    staticStyle: { "border-radius": "50%", padding: "2px" },
                    attrs: {
                      src: _vm.agentInfos.avatar,
                      username: _vm.agentInfos.agentName,
                      size: "38px"
                    }
                  })
                ],
                1
              )
            : _c("wz-avatar", {
                class: _vm.agentInfos.status,
                staticStyle: { "border-radius": "50%", padding: "2px" },
                attrs: {
                  src: _vm.agentInfos.avatar,
                  username: _vm.agentInfos.agentName,
                  size: "38px"
                }
              }),
          _vm._v(" "),
          _c(
            "v-list-tile-content",
            { staticClass: "wz_truncate listeAgentName" },
            [
              _c("v-list-tile-title", [
                _vm._v(_vm._s(_vm.agentInfos.agentName))
              ]),
              _vm._v(" "),
              _c("v-list-tile-sub-title", [
                _vm._v(_vm._s(_vm.agentInfos.jobAgent))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.agentInfos.status === "online" &&
                                    _vm.$store.getters["_User/account"].role ===
                                      "super" &&
                                    _vm.agentInfos.socketID !== "1",
                                  expression:
                                    "\n            agentInfos.status === 'online' &&\n            $store.getters['_User/account'].role === 'super' &&\n            agentInfos.socketID !== '1'\n          "
                                }
                              ],
                              attrs: { flat: "", icon: "", color: "pink" },
                              on: {
                                click: function($event) {
                                  _vm.showDialogConfirm = true
                                }
                              }
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [_c("v-icon", [_vm._v("person_off")])],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("btnAgentOffline")))])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "490" },
          model: {
            value: _vm.showDialogConfirm,
            callback: function($$v) {
              _vm.showDialogConfirm = $$v
            },
            expression: "showDialogConfirm"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm: _vm.$t("titelConfirmOffline"),
              contentDialogConfirm:
                "<strong>" +
                _vm.agentInfos.agentName +
                "</strong>" +
                _vm.$t("textConfirmOffline")
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirm,
              justCloseDialogConfirm: _vm.justCloseDialogConfirm,
              submitDialogConfirm: function($event) {
                return _vm.switchToStatus("offline")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-908f4bba", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-908f4bba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzWatcheeboxAgent.vue
// module id = null
// module chunks = 